import api from 'utils/api'
import {
  GET_DISPLAY_CATEGORIES_REQUESTED,
  GET_DISPLAY_CATEGORIES_SUCCEEDED,
  GET_DISPLAY_CATEGORIES_FAILED,
  UPDATE_DISPLAY_CATEGORIES_REQUESTED,
  UPDATE_DISPLAY_CATEGORIES_SUCCEEDED,
  UPDATE_DISPLAY_CATEGORIES_FAILED,
  CREATE_DISPLAY_CATEGORY_REQUESTED,
  CREATE_DISPLAY_CATEGORY_SUCCEEDED,
  CREATE_DISPLAY_CATEGORY_FAILED,
  SELECT_ITEMS_ASSIGNED_TO_DISPLAY_CATEGORY,
  SET_DISPLAY_CATEGORIES_SORTING_MODE,
  SET_DISPLAY_CATEGORIES_INDEXES,
} from './constants'

// get
export const getDisplayCategoriesRequested = () => ({
  type: GET_DISPLAY_CATEGORIES_REQUESTED,
})

export const getDisplayCategoriesSucceeded = (payload) => ({
  type: GET_DISPLAY_CATEGORIES_SUCCEEDED,
  payload,
})

export const getDisplayCategoriesFailed = () => ({
  type: GET_DISPLAY_CATEGORIES_FAILED,
})

export const loadDisplayCategories = (params) => (dispatch) => {
  dispatch(getDisplayCategoriesRequested())

  return api
    .fetchDisplayCategories(params)
    .then((response) =>
      dispatch(
        getDisplayCategoriesSucceeded(response.data.itemCategories)
      )
    )
    .catch(() => dispatch(getDisplayCategoriesFailed()))
}

// update
export const updateDisplayCategoriesRequested = () => ({
  type: UPDATE_DISPLAY_CATEGORIES_REQUESTED,
})

export const updateDisplayCategoriesSucceeded = (payload) => ({
  type: UPDATE_DISPLAY_CATEGORIES_SUCCEEDED,
  payload,
})

export const updateDisplayCategoriesFailed = () => ({
  type: UPDATE_DISPLAY_CATEGORIES_FAILED,
})

export const updateDisplayCategories = (data) => (dispatch) => {
  dispatch(updateDisplayCategoriesRequested())

  const params = { itemCategories: data }

  return api
    .updateDisplayCategories(params)
    .then((response) =>
      dispatch(
        updateDisplayCategoriesSucceeded(response.data.itemCategories)
      )
    )
    .catch(() => dispatch(updateDisplayCategoriesFailed()))
}

// create
export const createDisplayCategoryRequested = () => ({
  type: CREATE_DISPLAY_CATEGORY_REQUESTED,
})

export const createDisplayCategorySucceeded = (payload) => ({
  type: CREATE_DISPLAY_CATEGORY_SUCCEEDED,
  payload,
})

export const createDisplayCategoryFailed = () => ({
  type: CREATE_DISPLAY_CATEGORY_FAILED,
})

export const createDisplayCategory = (data) => (dispatch) => {
  dispatch(createDisplayCategoryRequested())

  const params = { itemCategories: data }

  return api
    .createDisplayCategories(params)
    .then((response) =>
      dispatch(
        createDisplayCategorySucceeded(response.data.itemCategories)
      )
    )
    .catch(() => dispatch(createDisplayCategoryFailed()))
}

export const selectItemsAssignedToDisplayCategory = (payload) => ({
  type: SELECT_ITEMS_ASSIGNED_TO_DISPLAY_CATEGORY,
  payload,
})

export const setDisplayCategoriesSortingMode = (payload) => ({
  type: SET_DISPLAY_CATEGORIES_SORTING_MODE,
  payload,
})

export const setDisplayCategoriesIndexes = (payload) => ({
  type: SET_DISPLAY_CATEGORIES_INDEXES,
  payload,
})
